/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ERPFivaldiIntegrationSettings'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ERPFivaldiIntegrationSettings'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPFivaldiIntegrationSettingsApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ERPFivaldiIntegrationSettings);
  }
}(this, function(ApiClient, ERPFivaldiIntegrationSettings) {
  'use strict';

  /**
   * ERPFivaldiIntegrationSettings service.
   * @module api/ERPFivaldiIntegrationSettingsApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ERPFivaldiIntegrationSettingsApi. 
   * @alias module:api/ERPFivaldiIntegrationSettingsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the eRPFivaldiIntegrationSettingsAddPut operation.
     * @callback module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ERPFivaldiIntegrationSettings} body 
     * @param {module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.eRPFivaldiIntegrationSettingsAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPFivaldiIntegrationSettingsAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPFivaldiIntegrationSettingsAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ERPFivaldiIntegrationSettings/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPFivaldiIntegrationSettingsCheckFivaldiConnectionPut operation.
     * @callback module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsCheckFivaldiConnectionPutCallback
     * @param {String} error Error message, if any.
     * @param {'Boolean'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * checkFivaldiConnection
     * @param {String} _4SAPIAppID 
     * @param {module:model/ERPFivaldiIntegrationSettings} body 
     * @param {module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsCheckFivaldiConnectionPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Boolean'}
     */
    this.eRPFivaldiIntegrationSettingsCheckFivaldiConnectionPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPFivaldiIntegrationSettingsCheckFivaldiConnectionPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPFivaldiIntegrationSettingsCheckFivaldiConnectionPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Boolean';

      return this.apiClient.callApi(
        '/ERPFivaldiIntegrationSettings/checkFivaldiConnection', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPFivaldiIntegrationSettingsDeleteGet operation.
     * @callback module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPFivaldiIntegrationSettingsDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPFivaldiIntegrationSettingsDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling eRPFivaldiIntegrationSettingsDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPFivaldiIntegrationSettings/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPFivaldiIntegrationSettingsEditPut operation.
     * @callback module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ERPFivaldiIntegrationSettings} body 
     * @param {Integer} primaryKey 
     * @param {module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPFivaldiIntegrationSettingsEditPut = function(_4SAPIAppID, body, primaryKey, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPFivaldiIntegrationSettingsEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPFivaldiIntegrationSettingsEditPut";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling eRPFivaldiIntegrationSettingsEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPFivaldiIntegrationSettings/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPFivaldiIntegrationSettingsLoadAllGet operation.
     * @callback module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ERPFivaldiIntegrationSettings>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ERPFivaldiIntegrationSettings>}
     */
    this.eRPFivaldiIntegrationSettingsLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPFivaldiIntegrationSettingsLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ERPFivaldiIntegrationSettings];

      return this.apiClient.callApi(
        '/ERPFivaldiIntegrationSettings/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPFivaldiIntegrationSettingsUpdateFivaldiDataGet operation.
     * @callback module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsUpdateFivaldiDataGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * updateFivaldiData
     * @param {String} _4SAPIAppID 
     * @param {module:api/ERPFivaldiIntegrationSettingsApi~eRPFivaldiIntegrationSettingsUpdateFivaldiDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPFivaldiIntegrationSettingsUpdateFivaldiDataGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPFivaldiIntegrationSettingsUpdateFivaldiDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPFivaldiIntegrationSettings/updateFivaldiData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
